import { registerTldrawLibraryVersion } from "@tldraw/utils";
import * as T from "./lib/validation.mjs";
import {
  ArrayOfValidator,
  DictValidator,
  ObjectValidator,
  UnionValidator,
  Validator
} from "./lib/validation.mjs";
registerTldrawLibraryVersion(
  "@tldraw/validate",
  "5.3.0",
  "esm"
);
export {
  ArrayOfValidator,
  DictValidator,
  ObjectValidator,
  T,
  UnionValidator,
  Validator
};
//# sourceMappingURL=index.mjs.map
